export function isEarlyBird(content, now = new Date()) {
  const cutoff = new Date(`${content.event.earlyBirdCutoff}T00:00:00`);
  return now < cutoff;
}

export function calculatePricing(attendees, content, now = new Date(), donation = 0) {
  const earlyBird = isEarlyBird(content, now);
  const group = attendees.length >= Number(content.pricing.groupMinimum);
  const unitPrice = earlyBird
    ? group
      ? Number(content.pricing.earlyBirdGroupPrice)
      : Number(content.pricing.earlyBirdPrice)
    : group
      ? Number(content.pricing.regularGroupPrice)
      : Number(content.pricing.regularPrice);
  const shirtCount = attendees.filter((attendee) => attendee.shirt !== 'No Shirt').length;
  const registrationSubtotal = attendees.length * unitPrice;
  const shirtSubtotal = shirtCount * Number(content.pricing.shirtPrice);
  const subtotal = registrationSubtotal + shirtSubtotal;
  const processingFee = Number((subtotal * (Number(content.pricing.processingFeePercent) / 100)).toFixed(2));
  const donationAmount = Number.isFinite(Number(donation)) ? Number(Math.max(0, Number(donation)).toFixed(2)) : 0;
  const total = Number((subtotal + processingFee + donationAmount).toFixed(2));

  return {
    earlyBird,
    group,
    attendeeCount: attendees.length,
    shirtCount,
    unitPrice,
    registrationSubtotal,
    shirtSubtotal,
    subtotal,
    processingFee,
    donationAmount,
    total
  };
}

export function validateDonation(donation) {
  const amount = Number(donation || 0);
  if (!Number.isFinite(amount) || amount < 0 || amount > 5000 || Math.abs(Math.round(amount * 100) - amount * 100) > 1e-8) {
    return 'Enter a valid optional contribution of $5,000 or less.';
  }
  return null;
}

export function validateRegistration(attendees, contact, content) {
  if (!content.event.registrationOpen) return 'Registration is currently closed.';
  if (!Array.isArray(attendees) || attendees.length < 1 || attendees.length > 30) {
    return 'Add at least one attendee.';
  }
  const validInstruments = new Set(content.registration.instruments);
  const validLevels = new Set(content.registration.levels);
  const validShirts = new Set(content.registration.shirts);
  for (const attendee of attendees) {
    if (!attendee?.fullName?.trim() || attendee.fullName.length > 120) return 'Every attendee needs a name.';
    if (!validInstruments.has(attendee.instrument)) return 'Choose a valid instrument for every attendee.';
    if (!validLevels.has(attendee.level)) return 'Choose a valid level for every attendee.';
    if (!validShirts.has(attendee.shirt)) return 'Choose a valid shirt option for every attendee.';
  }
  if (!contact?.fullName?.trim() || contact.fullName.length > 120) return 'Enter a contact name.';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact?.email || '')) return 'Enter a valid email address.';
  if (!contact?.phone?.trim() || contact.phone.length > 40) return 'Enter a phone number.';
  return null;
}
